module.exports = __webpack_public_path__ + "static/Libraromobile-2aa013f238c2714322642788440aa548.png";